import 'jquery';
import 'bootstrap';

const fillHiddenField = (form, idName) => {
  const snakeCased = idName.replace(/-/g, `_`);
  const formFieldEntry = form[`shipment[${snakeCased}]`];

  if (formFieldEntry) {
    $(`#${idName}`).val(formFieldEntry.value);
  }
};

const ShipmentSelectSlot = {
  bindManualClick() {
    $(`.manual-click`).click((e) => {
      e.preventDefault();
      [ `courier-slot-id`, `carrier-service-option-id`, `warehouse-id` ].forEach((id) => {
        fillHiddenField(e.target.form, id);
      });

      $(`#manual_slot_selection`).modal(`show`);
    });
  },

  bindToPage() {
    this.bindManualClick();
  },

  init() {
    if ($(`#shipment-select-slot`).length === 0) {
      return;
    }
    this.bindToPage();
  },
};

export default ShipmentSelectSlot;
